import React from 'react';
import { signInWithGoogle } from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';

const Login: React.FC = () => {
  const { accessDenied } = useAuth();
  const handleGoogleSignIn = async () => {
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error('Error signing in with Google:', error);
    }
  };

  return (
    <div style={{
      minHeight: '100dvh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Inter, system-ui, sans-serif'
    }}>
      <div style={{
        background: 'linear-gradient(145deg, rgba(30, 41, 59, 0.4), rgba(15, 23, 42, 0.8))',
        border: '1px solid rgba(51, 65, 85, 1)',
        borderRadius: '16px',
        padding: '3rem',
        maxWidth: '400px',
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
      }}>
        {/* Logo */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.75rem',
          marginBottom: '2rem'
        }}>
          <img 
            src="/logo.png" 
            alt="Quantify" 
            style={{ width: '80px', height: '80px', objectFit: 'cover', transform: 'scale(1.3)' }}
          />
          <div>
            <h1 style={{ 
              fontSize: '32px', 
              fontWeight: 'bold', 
              margin: 0, 
              color: '#f1f5f9',
              background: 'linear-gradient(135deg, #f1f5f9, #38bdf8)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
              Quantify
            </h1>
          </div>
        </div>

        {/* Access Denied Message */}
        {accessDenied && (
          <div style={{
            background: 'rgba(239, 68, 68, 0.1)',
            border: '1px solid rgba(239, 68, 68, 0.3)',
            borderRadius: '10px',
            padding: '0.75rem 1rem',
            marginBottom: '1rem',
            textAlign: 'center',
          }}>
            <p style={{ color: '#f87171', fontSize: '13px', margin: 0, fontWeight: 500 }}>
              Access denied. Your account is not authorized.
            </p>
            <p style={{ color: '#94a3b8', fontSize: '11px', margin: '4px 0 0 0' }}>
              Contact the admin to request access.
            </p>
          </div>
        )}

        {/* Sign In Button */}
        <button
          onClick={handleGoogleSignIn}
          style={{
            width: '100%',
            background: 'linear-gradient(135deg, #4285f4, #34a853)',
            color: 'white',
            border: 'none',
            padding: '1rem 2rem',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.75rem',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            marginBottom: '1.5rem'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-1px)';
            e.currentTarget.style.boxShadow = '0 10px 16px -4px rgba(0, 0, 0, 0.1)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
          }}
        >
          <svg 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="currentColor"
          >
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Continue with Google
        </button>

        {/* Footer */}
        <p style={{ 
          color: '#64748b', 
          fontSize: '12px', 
          margin: 0,
          lineHeight: '1.4'
        }}>
          <strong>DISCLAIMER:</strong> This is not financial advice. This platform is for educational and informational purposes only. 
          All trading strategies and recommendations are provided as educational content. Past performance does not guarantee future results. 
          Please consult with a qualified financial advisor before making investment decisions. Trading options involves substantial risk and may not be suitable for all investors.
        </p>
      </div>
    </div>
  );
};

export default Login;